import { render, staticRenderFns } from "./ownDinner.vue?vue&type=template&id=66bb8f2b&"
import script from "./ownDinner.vue?vue&type=script&lang=js&"
export * from "./ownDinner.vue?vue&type=script&lang=js&"
import style0 from "./ownDinner.vue?vue&type=style&index=0&id=66bb8f2b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports